import React, { Component } from 'react';
import * as Sentry from '@sentry/react';
import ErrorPage from './ErrorPage';

class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // ✅ Log error to Sentry
    Sentry.captureException(error, { extra: errorInfo });

    // Also log to console (optional)
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;